exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".BasemapCard {\n    clear: both;\n    z-index: 1010;\n    margin: 8px 4px 8px 4px;\n}\n\n.BasemapCard-header {\n    height: 56px;\n    padding-left: 14px;\n    padding-right: 8px;\n    margin-right: -8px;\n    font-size: 10px;\n}\n\n.BasemapCard-header span {\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n}\n\n\n.BasemapCard-toolbar {\n    background-color: #eee;\n    height: 32px;\n    padding-left: 7px;\n}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./src/components/layers/basemaps/BasemapCard.css
// module id = 1005
// module chunks = 0